import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import PageNotFound from './pages/pageNotFound/PageNotFound';
import Home from "./pages/home/Home";
import Movies from "./pages/movies/Movies";
import TVShows from "./pages/shows/TVShows";
import HomeDetails from "./pages/home/HomeItemDetails";
import ShowDetails from "./pages/shows/TVShowDetails";
import MovieDetails from "./pages/movies/MovieDetails";
import Search from "./pages/search/Search";
import SearchDetails from "./pages/search/SearchDetails";

function App() {
  
  return (
    <Router>

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/movie-tv/:movieId" element={<HomeDetails />} />

      <Route path="/movies" element={<Movies />} />
      <Route path="/movie/:movieId" element={<MovieDetails />} />

      <Route path="/tv-shows" element={<TVShows />} />
      <Route path="/tv-show/:movieId" element={<ShowDetails />} />

      <Route path="/search/:query" element={<Search />} />
      <Route path="/movie-tv/search/:movieId" element={<SearchDetails />} />
      
      <Route path="/*" element={<PageNotFound />} />
    </Routes>
    
    </Router>
  );
}

export default App;
